// Identità team: SINGLE SOURCE dagli utenti interni reali (backend).
// Fonte di verità: /api/users/team-directory (Utenti & Permessi). Nessun mock,
// nessun localStorage. Cache in-memory idratata al login, come gli altri layer.
import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

export const ROLES = { super_admin: "Super Admin", team: "Team", cliente: "Cliente" };

let _team = [];
let _version = 0;
const subs = new Set();
const notify = () => { _version += 1; subs.forEach((f) => f()); };

export const subscribeTeam = (fn) => { subs.add(fn); return () => subs.delete(fn); };
export const useTeam = () =>
  useSyncExternalStore((cb) => subscribeTeam(cb), () => _version, () => _version);

export async function hydrateTeam() {
  try { _team = await api.get("/users/team-directory").then((r) => r.data); }
  catch { _team = []; }
  notify();
}

export function resetTeam() { _team = []; notify(); }

export const listTeam = () => _team;
export const getMember = (id) => _team.find((m) => m.id === id) || null;
export const memberRole = (id) => _team.find((m) => m.id === id)?.role || null;
export const memberName = (id) => _team.find((m) => m.id === id)?.name || "—";
